import { render, staticRenderFns } from "./DepenseTotal.vue?vue&type=template&id=2f76fd47"
import script from "./DepenseTotal.vue?vue&type=script&lang=js"
export * from "./DepenseTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports